import React from 'react';
import logo from '../../assets/images/logo.png';
import { Link } from 'react-router-dom';

const Login = () => {
  return (
    <div class="auth-wrapper">
        <div class="auth-content">
            <div class="auth-bg">
                <span class="r"></span>
                <span class="r s"></span>
                <span class="r s"></span>
                <span class="r"></span>
            </div>
            <div class="card">
                <div class="card-body text-center">
                    <div class="mb-4">
                        {/* <i class="feather icon-unlock auth-icon"></i> */}
                        <img style={{width: '100px'}} src={logo} alt="" />
                    </div>
                    <h3 class="mb-4">Login</h3>
                    <div class="input-group mb-3">
                        <input type="text" class="form-control" placeholder="Phone Number" />
                    </div>
                    <div class="input-group mb-4">
                        <input type="password" class="form-control" placeholder="password" />
                    </div>
                    <div class="form-group text-left">
                        <div class="checkbox checkbox-fill d-inline">
                            <input type="checkbox" name="checkbox-fill-1" id="checkbox-fill-a1" checked="" />
                            <label for="checkbox-fill-a1" class="cr">Keep me logged in</label>
                        </div>
                    </div>
                    <button class="btn btn-primary shadow-2 mb-4">Login</button>
                    <p class="mb-2 text-muted">Forgot password? <Link to="/forgot-password">Reset</Link></p>
                    <p class="mb-0 text-muted">Don’t have an account? <Link to="/signup">Signup</Link></p>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Login